<template>
  <page :manualInit="claimStaging.init" :manualErr="claimStaging.initErr" @reload="doInit">
    <div v-if="renderAppType">
      <v-subheader>
        {{labels.appID}}
      </v-subheader>
      <v-container fluid grid-list-lg class="mb-3">
        <v-layout row wrap>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['travelClaim', 'travelClaimQuery'])">
            <v-card :class="isMatchRoute('travelClaimStaging') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'travelClaimStaging' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.TRAVEL}}</v-icon>
                <span>Travel</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['fireClaim', 'fireClaimQuery'])">
            <v-card :class="isMatchRoute('fireClaimStaging') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'fireClaimStaging' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.FIRE}}</v-icon>
                <span>Fire</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['maidClaim', 'maidClaimQuery'])">
            <v-card :class="isMatchRoute('maidClaimStaging') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'maidClaimStaging' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MAID}}</v-icon>
                <span>Maid</span>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div>
      <transition name="slide-x-transition" mode="out-in">
        <router-view ></router-view>
      </transition>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import routeMixin from '@/mixins/route'
import { appIcon } from '@/const/underwriting'
export default {
  data() {
    return {
      labels: {
        appID: 'Application Type'
      }
    }
  },
  mounted() {
    this.doInit()
  },
  methods: {
    doInit() {
      this.$store.dispatch('claimStagingInit')
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    appIcon() {
      return appIcon
    },
    claimStaging() {
      return this.$store.state.claimStaging
    },
    renderAppType() {
      if (this.isMatchRouteExact('claimStaging') ||
        this.isMatchRouteExact('travelClaimStaging') ||
        this.isMatchRouteExact('fireClaimStaging') ||
        this.isMatchRouteExact('maidClaimStaging')) {
        return true
      } else {
        return false
      }
    }
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
@import "../../assets/scss/agency.scss";
</style>
